module.exports = __webpack_public_path__ + "static/media/queue_4000x2500_3.54b3c1d0.jpg";